import React, { Component, useEffect, useState } from "react";
import Form from "../../comman/form";
import { Modal, Button } from "react-bootstrap";
import config from "../../config.json";
import http from "../../services/HttpService";
import auth from "../../services/authService";
import Swal from "sweetalert2";
import UploadDocument from "../../comman/UploadDocument";
import UploadRepository from "../../app/components/Document/UploadRepository";
import { getCurrentUser } from "../../app/store/auth";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import {
  ddrmsRepoDocumentUploaded,
  getDdrmsRepoUploadStatus,
  UploadDdrmsRepositoryDocs,
} from "../../app/store/ddrmsDocument";
import {
  getLocalDocUploadSasUrl,
  getLocalDocUploadStatus,
  getUploadDocumentId,
  localDocumentUploaded,
  uploadDocument,
  uploadLocalDocument,
} from "../../app/store/documents";
import UploadLocal from "../../app/components/Document/UploadLocal";
import { uploadFileToBlob } from "../../services/blobUploadService";

const CandidateReqDoc = (props) => {
  const {
    docShowHide,
    handleDocShowHide,
    sendType,
    workItem,
    uploadType,
    applicantObj,
    viewType,
    uploadDocType,
  } = props;

  const [submitProcess, setSubmitProcess] = useState(false);
  const [useType, setUseType] = useState("sharing");
  const [isPwd, setIsPwd] = useState("");
  const [message, setMessage] = useState("");
  const [selectedRepoDocs, setSelectedRepoDocs] = useState([]);
  const [localDocs, setLocalDocs] = useState([]);

  const ddrmsRepoUploadStatus = useSelector(getDdrmsRepoUploadStatus);
  const localDocUploadStatusSelector = useSelector(getLocalDocUploadStatus);
  const localDocUploadSasUrlSelector = useSelector(getLocalDocUploadSasUrl);

  const currentUser = getCurrentUser();

  const dispatch = useDispatch();

  useEffect(() => {
    setMessage("");
    setLocalDocs([]);
    setSelectedRepoDocs([]);
    setIsPwd("");
    setUseType("");
  }, [docShowHide]);

  const doSubmit = () => {
    let docType = "";
    if (uploadType) docType = uploadType;
    if (uploadDocType) docType = uploadDocType;
    if (sendType === "repository") saveRepoDocs(docType);
    if (sendType === "upload") saveLocalDocs(docType);
  };

  const saveRepoDocs = async (docType) => {
    let wfTask = { ...workItem };
    wfTask.performerId = currentUser.id;
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        wfTask.applicantId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        wfTask.applicantId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        wfTask.applicantId = applicantObj?.id;
      if (
        (uploadType?.includes("ach_") || uploadType?.includes("insurance_")) &&
        applicantObj?.applicantId
      ) {
        wfTask.applicantId = applicantObj.applicantId;
        wfTask.performerId = parseInt(currentUser.id);
      }
    } else if (applicantObj?.id) {
      wfTask.applicantId = applicantObj?.id;
    }

    const frmData = new FormData();
    frmData.append("message", message);
    frmData.append("workflowTask", JSON.stringify(wfTask));
    frmData.append("updType", useType);
    frmData.append("isPwd", isPwd);
    //frmData.append("userId", usrId);
    const updDocs = selectedRepoDocs.map((doc) => {
      const newDoc = { ...doc };
      newDoc.docType = docType;
      return newDoc;
    });
    frmData.append("doc", JSON.stringify(updDocs));

    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Upload this Document?",
      "warning"
    );
    if (result.isConfirmed) {
      setSubmitProcess(true);
      dispatch(UploadDdrmsRepositoryDocs(frmData));
    }
  };

  useEffect(() => {
    if (ddrmsRepoUploadStatus) {
      setSubmitProcess(false);
      handleDocShowHide("save");
      getAlert("", "Document Uploaded Successfully", "success");
      dispatch(ddrmsRepoDocumentUploaded({ status: false }));
    }
  }, [ddrmsRepoUploadStatus]);



  const saveLocalDocs = async (docType) => {
    const wfTask = { ...workItem };
    //wfTask.performerId = workItem.applicantId;
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        wfTask.performerId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        wfTask.performerId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        wfTask.performerId = applicantObj?.id;
      if (
        (uploadType?.includes("ach_") || uploadType?.includes("insurance_")) &&
        applicantObj?.applicantId
      ) {
        usrId = applicantObj.applicantId;
        wfTask.performerId = parseInt(currentUser.id);
      }
    } else if (applicantObj?.id) {
      wfTask.performerId = applicantObj?.id;
    }

    if (docType?.includes("req_")) {
      usrId = wfTask.performerId;
      wfTask.performerId = parseInt(currentUser.id);
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid) {
        usrId = applicantObj.recruiter.parentid;
        wfTask.performerId = applicantObj?.id;
      }
      if (uploadType === "Subcontractor" && applicantObj?.subcontractor?.parentid) {
        usrId = applicantObj.subcontractor.parentid;
        wfTask.performerId = applicantObj?.id;
      }
    }

    const frmData = new FormData();
    frmData.append("message", message);
    frmData.append("workflowTask", JSON.stringify(wfTask));
    frmData.append("userId", usrId);
    // localDocs.map((file, key) =>
    //   frmData.append("files[" + key + "]", file.file)
    // );
    frmData.append("files", JSON.stringify(localDocs.map((file) => ({ name: file.name, type: file.type, size: file.size }))));
    frmData.append("docType", docType);
    if (!useType) frmData.append("updType", docType);
    else frmData.append("updType", useType);
    frmData.append("isPwd", isPwd);

    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Upload this Document?",
      "warning"
    );
    if (result.isConfirmed) {
      setSubmitProcess(true);
      dispatch(uploadLocalDocument(frmData));
    }
  };

  useEffect(() => {
    if (localDocUploadStatusSelector > 0) {
      setSubmitProcess(false);
      handleDocShowHide("save");
      getAlert("", "Document Uploaded Successfully", "success");
    }
  }, [localDocUploadStatusSelector]);

  useEffect(() => {

    const uploadAllDocuments = async () => {
      if (localDocUploadSasUrlSelector && localDocUploadSasUrlSelector?.length > 0) {
        try {
          await Promise.all(
            localDocs.map((file, key) =>
              uploadFileToBlob(
                file.file,
                localDocUploadSasUrlSelector[key]?.uploadUrl,
                (progress) => {
                  console.log(`Upload progress: ${progress}%`);
                }
              )
            )
          );

          // Runs only after ALL uploads finish   
          console.log("All files uploaded successfully!");
          dispatch(localDocumentUploaded(null));
        } catch (error) {
          console.error("Upload failed:", error);
        }
      }
    };

    uploadAllDocuments();
  }, [localDocUploadSasUrlSelector]);

  const handlePwdChecked = ({ currentTarget }) => {
    if (currentTarget.checked) {
      if (uploadType === "Subcontractor") {
        if (applicantObj.performerid) {
          const pfId = applicantObj.subcontractor.fuid;
          const pfName = applicantObj.subcontractor.label
            .substring(0, 3)
            .toLowerCase();
          setIsPwd(pfName + pfId);
        } else {
          const pfId = applicantObj.fuid;
          const pfName = applicantObj.label.substring(0, 3).toLowerCase();
          setIsPwd(pfName + pfId);
        }
      } else if (uploadType === "Recruiter") {
        if (applicantObj.performerid) {
          const pfId = applicantObj.recruiter.fuid;
          const pfName = applicantObj.recruiter.label
            .substring(0, 3)
            .toLowerCase();
          setIsPwd(pfName + pfId);
        } else {
          const pfId = applicantObj.fuid;
          const pfName = applicantObj.label.substring(0, 3).toLowerCase();
          setIsPwd(pfName + pfId);
        }
      } else if (uploadType === "Candidate") {
        const pfId = applicantObj.performerid;
        const pfName = applicantObj.performername.substring(0, 3).toLowerCase();
        setIsPwd(pfName + pfId);
      }
    } else {
      setIsPwd("");
    }
  };

  const handleUseTypeSelect = ({ currentTarget }) => {
    if (currentTarget.checked) setUseType("internal");
    else setUseType("sharing");
  };

  return (
    <Modal show={docShowHide} size="xl">
      <Modal.Header closeButton onHide={() => handleDocShowHide("")}>
        <Modal.Title>
          {sendType === "repository"
            ? "Upload from DDRMS Repository"
            : "Upload from Local Drive"}{" "}
          - {uploadType?.toUpperCase()}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="border">
        <div className="row">
          {sendType === "repository" && (
            <UploadRepository
              workItem={workItem}
              setSelectedRepoDocs={setSelectedRepoDocs}
            />
          )}

          {sendType === "upload" && (
            <div className="col-md-12">
              <UploadLocal setLocalDocs={setLocalDocs} />
            </div>
          )}
          {!(
            uploadType === "msp" ||
            uploadType === "agency" ||
            uploadType === "ProjectInfo" ||
            uploadType?.includes("ach_") ||
            uploadType?.includes("insurance_") ||
            uploadDocType?.includes("req_") ||
            uploadDocType === "reporting"
          ) && (
              <>
                <>
                  <div className="col-md-12 form-inline form-group">
                    <div className="custom-control custom-checkbox">
                      <input
                        name="useType"
                        className="custom-control-input"
                        id="internal"
                        value="internal"
                        type="checkbox"
                        onChange={handleUseTypeSelect}
                        checked={useType === "internal"}
                      />
                      <label className="custom-control-label" htmlFor="internal">
                        For Internal Purposes Only
                      </label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="custom-control custom-checkbox mb-3">
                      <input
                        className="custom-control-input"
                        id="isPwd"
                        name="isPwd"
                        type="checkbox"
                        onChange={handlePwdChecked}
                      />
                      <label className="custom-control-label" htmlFor="isPwd">
                        Check Box if you want the document to sent as password
                        protected
                      </label>
                      <p className="text-danger">
                        (Example : First 3 letters of applicant's name and
                        starting 3 charactors of the applicant's ID in lower case)
                        (abc123).
                      </p>
                    </div>
                  </div>
                </>

                <div className="col-md-12">
                  <label htmlFor="message" className="form-control-label">
                    Notes
                    <span className="font-weight-normal ml-2">
                      (Add any additional message you may want to send)
                    </span>
                  </label>

                  <textarea
                    className="form-control"
                    id="message"
                    name="massage"
                    placeholder="Notes"
                    onChange={({ currentTarget }) =>
                      setMessage(currentTarget.value)
                    }
                    value={message}
                  ></textarea>
                </div>
              </>
            )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {/* <button className="btn btn-sm btn-outline-default" onClick={() => handleDocShowHide("")}>
          <i class="fa fa-times" aria-hidden="true"></i> Close
        </button> */}
        <button
          className="btn btn-sm btn-outline-default"
          disabled={
            submitProcess ||
            (sendType === "repository" && selectedRepoDocs.length === 0) ||
            (sendType === "upload" && localDocs.length === 0)
          }
          onClick={doSubmit}
        >
          {submitProcess ? (
            <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
          ) : (
            <i class="fa fa-check" aria-hidden="true"></i>
          )}{" "}
          Attach
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CandidateReqDoc;
